import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { categoryQueryKeys } from 'api/repositories/category/category.constants';
import {
  CategoriesDto,
  GetCategoriesRequestParams,
  GetCategoriesResponse,
} from 'api/repositories/category/category.types';
import { getLanguage } from 'assets/languages';

interface UseGetCategoriesProps {
  params?: GetCategoriesRequestParams;
  options?: Omit<UseQueryOptions<GetCategoriesResponse, Error, CategoriesDto>, 'queryKey' | 'queryFn'>;
}

function useGetCategories({ params, options }: UseGetCategoriesProps) {
  return useQuery({
    ...categoryQueryKeys.getCategories(params),
    select: (data) => {
      const categories = data.data.categories;

      /*
       * TODO: 카테고리 미지정 데이터 노출되지 않게 임시 처리
       * 기존 뷰티 카테고리 -> 카테고리 미지정으로 처리 후 운영에서 수동으로 모두 전환 완료 후 삭제 예정
       */
      const filteredCategories = categories.filter((category) => {
        return category.name !== '카테고리 미지정';
      });

      const currentLanguage = getLanguage();
      for (let i = 0; i < filteredCategories.length; i++) {
        if (currentLanguage === 'ko') {
          filteredCategories[i].name = filteredCategories[i].nameKo;
        } else if (currentLanguage === 'ja') {
          filteredCategories[i].name = filteredCategories[i].nameJa;
        }
      }

      return filteredCategories;
    },
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  });
}

export default useGetCategories;
